'use client';

import { useEffect, useState } from 'react';
import { Button } from '@/features/button';
import { IconHeart, IconHeartFilled } from '@/features/icons';
import { useMobileDetect } from '@/features/mobile-detect-context/mobile-detect-provider';
import { Modal } from '@/features/modal';
import { Webengage } from '@/features/webengage';
import { SupportedEvents } from '@/features/webengage/types';
import useDeleteWishlist from '@/app/(pdp)/_utils/use-delete-wishlist';
import { useGetWishlist } from '@/app/(pdp)/_utils/use-get-wishlist';
import usePDPData from '@/app/(pdp)/_utils/use-pdp-data';
import usePostWishlist from '@/app/(pdp)/_utils/use-post-wishlist';
import { useNavigateLogin } from '@/app/_utils/session/use-navigate-login';
import useUser from '@/utils/use-user';
import WishlistButtonSkeleton from './skeleton';
function WishlistButton() {
  const {
    isMobile
  } = useMobileDetect();
  const navigateLogin = useNavigateLogin();
  const {
    isLoggedIn
  } = useUser();
  const {
    data
  } = usePDPData();
  const {
    data: wishlistData,
    isFetching
  } = useGetWishlist(data?.id || '', isLoggedIn);
  const [isLiked, setIsLiked] = useState<boolean>(wishlistData || false);
  const {
    mutate: mutatePost
  } = usePostWishlist();
  const {
    mutate: mutateDelete
  } = useDeleteWishlist();
  const [isOpen, setIsOpen] = useState(false);
  const handleAddToWishlist = () => {
    if (!isLoggedIn) {
      setIsOpen(true);
      return;
    }
    mutatePost({
      productId: data?.id || ''
    }, {
      onSuccess: () => {
        Webengage.trackWhishlist(data ?? {}, SupportedEvents.add_to_favorite);
        setIsLiked(true);
      }
    });
  };
  const handleRemoveFromWishlist = () => {
    if (!isLoggedIn) {
      setIsOpen(true);
      return;
    }
    mutateDelete({
      productId: data?.id || ''
    }, {
      onSuccess: () => {
        Webengage.trackWhishlist(data ?? {}, SupportedEvents.remove_from_favorite);
        setIsLiked(false);
      }
    });
  };
  useEffect(() => {
    setIsLiked(wishlistData);
  }, [wishlistData]);
  if (isFetching) return <WishlistButtonSkeleton />;
  return <>
            {isLiked ? <button aria-label='delete-from-wishlist' onClick={handleRemoveFromWishlist}>
                    <IconHeartFilled className='h-6 w-6 text-primary-main' />
                </button> : <button aria-label='add-to-wishlist' onClick={handleAddToWishlist}>
                    <IconHeart className='h-6 w-6 text-primary-main' />
                </button>}

            <Modal isOpen={isOpen} handleClose={() => setIsOpen(false)} width='lg:w-[508px] w-full' title='افزودن به علاقه‌مندی‌ها' data-sentry-element="Modal" data-sentry-source-file="wishlist-button.tsx">
                <p className='text-body-14 text-text-black lg:text-body-16'>
                    برای افزودن محصول به لیست علاقه‌مندی‌ها، لطفا ابتدا وارد شوید.
                </p>

                <Button size={isMobile ? 'medium' : 'large'} className='mx-auto mt-6' graphicStyle='filled' onClick={() => navigateLogin()} data-sentry-element="Button" data-sentry-source-file="wishlist-button.tsx">
                    ورود به حساب کاربری
                </Button>
            </Modal>
        </>;
}
export default WishlistButton;